import ListItem from '@material-ui/core/ListItem/ListItem';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import EllipsisWithTooltip from './EllipsisWithTooltip';
import React from 'react';
import {withStyles} from '@material-ui/core';
import classNames from 'classnames';

const RenderDetailsRow = ({label, value, showIfEmpty, children, classes, labelClass}) => {
    if (!showIfEmpty && !value) {
        return '';
    }

    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography className={classNames(classes.detailsLabel, labelClass) } component={'div'}
                                variant={'subtitle2'}>{(<EllipsisWithTooltip>{label}</EllipsisWithTooltip>)}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography className={classes.detailsValue} component={'div'}
                                variant={'body2'}>{children || value}</Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};

const defaultLineHeight = 1.8;

const styles = theme => ({
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        margin: '0 30px 0 0',
        '&:last-child': {
            padding: 0,
        },
    },
    detailsLabel: {
        textAlign: 'right',
        lineHeight: defaultLineHeight,
    },
    detailsValue: {
        lineHeight: defaultLineHeight,
        '& > *': {
            ...theme.helpers.oneLiner,
        },
        '& > span': {
            display: 'inline',
        },
    },
    detailsRow: {
        paddingTop: 0,
        paddingBottom: 0,
    },
});

export default withStyles(styles)(RenderDetailsRow);
